import { IMenu } from '@poste-click-connect/shared-ui';
import { Path } from '../enums/path.enum';

export const primaryMenuLogged: IMenu[] = [
  {
    label: 'Aiutaci a migliorare!',
    id: 'survey',
    icon: 'assets/survey.png',
  },
  {
    label: 'Guida flash',
    id: 'flash',
    icon: 'assets/help-overlay.svg',
  },
  {
    label: 'Help',
    id: Path.HELP,
    icon: 'assets/help.png',
  },
  {
    label: 'Logout',
    id: 'logout',
    icon: 'assets/logout.svg',
  },
];

export const primaryMenuLoggedNoSurvey: IMenu[] = [
  {
    label: 'Guida flash',
    id: 'flash',
    icon: 'assets/help-overlay.svg',
  },
  {
    label: 'Help',
    id: Path.HELP,
    icon: 'assets/help.png',
  },
  {
    label: 'Logout',
    id: 'logout',
    icon: 'assets/logout.svg',
  },
];

export const primaryMenuLottomatica: IMenu[] = [
  {
    label: 'Aiutaci a migliorare!',
    id: 'survey',
    icon: 'assets/survey.png',
  },
  {
    label: 'Guida flash',
    id: 'flash',
    icon: 'assets/help-overlay.svg',
  },
  {
    label: 'Help',
    id: Path.HELP,
    icon: 'assets/help.png',
  }
];

export const primaryMenuLottomaticaNoSurvey: IMenu[] = [
  {
    label: 'Guida flash',
    id: 'flash',
    icon: 'assets/help-overlay.svg',
  },
  {
    label: 'Help',
    id: Path.HELP,
    icon: 'assets/help.png',
  }
];

export const primaryMenuNotLogged: IMenu[] = [
  {
    label: 'Help',
    id: Path.HELP,
    icon: 'assets/help.png',
  },
  {
    label: 'Login',
    id: Path.LOGIN,
    icon: 'assets/login.svg',
  },
];

export const secondaryMenu: IMenu[] = [
  {
    label: 'Gestione Punto Poste',
    id: Path.GESTIONE_PUNTOPOSTE,
    icon: 'assets/gestionePP.svg'
  },
  {
    label: 'Bacheca',
    id: Path.BACHECA,
    icon: 'assets/notification.svg',
  },
];

export const secondaryMenuMobile: IMenu[] = [
  {
    label: 'Gestione Punto Poste',
    id: Path.GESTIONE_PUNTOPOSTE,
  },
  {
    label: 'Bacheca',
    id: Path.BACHECA,
    icon: 'assets/notification-black.svg',
  },
];

export const publicPaths: string[] = [
  Path.LOGIN,
  Path.RECUPERO_PASSWORD,
  Path.HELP,
  Path.TERMINI_CONDIZIONI,
];
